// src/components/Hero.js
import React from 'react';
import LexingtonAnimation from './LexingtonAnimation';

const Hero = () => {
  return (
    <section
      id="home"
      className="relative w-full h-screen overflow-x-hidden pt-20 md:pt-0"  // added top padding on mobile
    >
      {/* Full-Width Background */}
      <div className="absolute inset-0 z-0">
        <iframe
          src="/nn.html"
          title="Neural Network Visualization"
          className="block w-full h-full pointer-events-none border-0"
        />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ backgroundColor: "rgba(13, 13, 13, 0.75)" }}
        ></div>
        {/* Top gradient overlay to avoid any visible seam at the very top */}
        <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-[#0d0d0d] to-transparent pointer-events-none"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 flex flex-col justify-center h-full">
        {/* Profile Section */}
        <div className="text-center px-4 mb-8">
          <div className="flex items-center justify-center flex-wrap">
            <img
              src="../../vendor/pfp.png"
              alt="Profile"
              className="w-12 h-12 md:w-16 md:h-16 rounded-full mr-3"
            />
            <div>
              <h1 className="text-[#e0dadd] text-2xl md:text-3xl font-extrabold">
                Koby Pierce
              </h1>
              <p className="text-[#e0dadd] text-sm md:text-base">
                <LexingtonAnimation />
              </p>
            </div>
          </div>
        </div>

        {/* Main Headline */}
        <div className="text-center px-4">
          <h2 className="text-4xl md:text-6xl font-extrabold text-white leading-tight">
            Building the <span className="text-blue-500">Technology</span> of<br />
            the <span className="text-blue-500">Future</span>
          </h2>
        </div>

        {/* Secondary Content */}
        <div className="mt-8 max-w-4xl mx-auto px-4 text-center">
          <p className="mt-4 text-lg md:text-2xl text-gray-300">
            Welcome to my digital sanctuary! I'm building companies, exploring AI, building reliable cloud, 
            spreading internet access, and researching space technology, and sharing my authentic journey. 
            From <span className="text-blue-500">Hybrid Hosting</span> to{" "}
            <span className="text-blue-500">AI research</span>, this is where I share it all.
          </p>
          <div className="flex flex-wrap justify-center space-x-2 md:space-x-4 mt-8">
            <a
              href="#work"
              className="px-6 py-3 md:px-8 md:py-4 bg-blue-900 hover:bg-blue-800 text-white rounded-md transition text-base md:text-xl font-bold mb-2"
            >
              See My Work
            </a>
            <a
              href="/blog"
              className="px-6 py-3 md:px-8 md:py-4 bg-transparent backdrop-blur-sm border-2 border-gray-400 text-white hover:bg-gray-500/10 hover:text-gray-300 rounded-md transition text-base md:text-xl font-bold mb-2"
            >
              Read My Blog
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
